import React, { useState } from 'react';
import { Form, Dropdown, Button, InputGroup } from 'react-bootstrap';

function WatchlistFormDynamic({
      userWatchlist = [{'user_watchlist_id': 0, 'watchlist_name': 'Default'}], 
      newWatchlistOption,
      onHide,
      onSubmit}) {
  const [watchlists, setWatchlists] = useState(userWatchlist);
  const [selectedWatchlist, setSelectedWatchlist] = useState('');
  const [newWatchlist, setNewWatchlist] = useState('');
  const [newWatchlistItems, setNewWatchlistItems] = useState([]);
  const [showInput, setShowInput] = useState(false);

  // Handle selection of existing items
  const handleSelect = (eventKey) => {
    if (eventKey === 'ADD_NEW') {
      setShowInput(true);
    } else {
      setSelectedWatchlist(eventKey);
      setShowInput(false);
    }
  };

  // Handle adding a new item
  const handleAddItem = () => {
    const newWatchlistItem = newWatchlist.trim();
    if ( newWatchlistItem && !watchlists.includes(newWatchlistItem)) {
      setShowInput(false);
      onSubmit({
        'watchlistName': newWatchlistItem,
        'addNewWatchlist': true
      })
    }
  };

  const handleContinue = () => {
    onSubmit({
      'watchlistName': selectedWatchlist,
      'addNewWatchlist': false
    });

  }

  const isBlank = (value) => {
    return !value || value.trim().length === 0;
  }

  return (
    <Form className="p-3" style={{ maxWidth: '400px' }}>
      <Form.Group className="mb-3">
        <Form.Label>
          {
            newWatchlistOption? (<b>Select Existing or Add New Watchlist</b>) : (<b>Select Watchlist</b>)
          }
        </Form.Label>
        
        {/* Custom Toggle or showing selected value */}
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="No item selected"
            value={selectedWatchlist}
            readOnly
            className="bg-white"
          />
          <Dropdown onSelect={handleSelect}>
            <Dropdown.Toggle variant="outline-secondary" id="dropdown-custom-components" />

            <Dropdown.Menu>
              {watchlists.map((item, index) => (
                <Dropdown.Item key={item.user_watchlist_id} eventKey={item.watchlist_name} active={selectedWatchlist === item}>
                  {item.watchlist_name}
                </Dropdown.Item>
              ))}
              {
                newWatchlistOption ? (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="ADD_NEW" className="text-primary fw-bold">
                      + Add New Item
                    </Dropdown.Item>
                  </>
                ) : (<></>)
              }
            </Dropdown.Menu>
          </Dropdown>
        </InputGroup>

        {/* Dynamic Input Field to add a new item */}
        {showInput ? (
            <InputGroup className="mt-2">
                <Form.Control
                type="text"
                placeholder="Enter new watchlist name..."
                value={newWatchlist}
                onChange={(e) => setNewWatchlist(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAddItem()}
                />
                <Button variant="success" onClick={handleAddItem}>
                   Add And Continue
                </Button>
            </InputGroup>
            ): (
               <>
                  <Button variant="success" onClick={handleContinue} disabled={isBlank(selectedWatchlist)} >
                      Continue
                  </Button>  

                </>
            )
        }
        <Button variant="secondary" onClick={onHide}>
            Cancel
        </Button> 

      </Form.Group>
    </Form>
  );
}

export default WatchlistFormDynamic;
